import { render, staticRenderFns } from "./CorpTagChips.vue?vue&type=template&id=3c5b7099&scoped=true"
import script from "./CorpTagChips.vue?vue&type=script&lang=js"
export * from "./CorpTagChips.vue?vue&type=script&lang=js"
import style0 from "./CorpTagChips.vue?vue&type=style&index=0&id=3c5b7099&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5b7099",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
